import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  user: any = {}
  errorMsg: string;
  registration: boolean = false;

  constructor(
    private router: Router,
    public authService: AuthService,
    public userService: UserService) { }

  ngOnInit() { }

  doEmailLogin() {
    this.processResponse(this.authService.doEmailLogin(this.user));
  }

  doGoogleLogin() {
    this.authService.doGoogleLogin()
      .then(res => {
        if (res.additionalUserInfo.isNewUser) {
          this.user.name = res.user.displayName;
          this.user.email = res.user.email;
          this.user.emailVerified = res.user.emailVerified;
          this.user.provider = "Google";
          this.userService.setCurrentUserDetails(this.user);
        }
        this.router.navigate(['']);
      }, err => {
        this.errorMsg = err.message;
      });
  }

  doRegistration() {
    // check email and password are same
    if (this.user.email != this.user.emailConfirm || this.user.password != this.user.passwordConfirm) {
      this.errorMsg = "Email address or passwords don't match. Please try again!";
      return;
    }
    this.user.emailVerified = false;
    this.user.provider = "Email";

    this.authService.doEmailRegistration(this.user, this.user.password)
      .then(res => {
        // this.userService.setCurrentUserDetails(this.user);
        this.router.navigate(['']);
      }, err => {
        this.errorMsg = err.message;
      });
  }

  processResponse(promise) {
    promise.then(res => {
      this.router.navigate(['']);
    }, err => {
      this.errorMsg = err.message;
    });
  }

  toggleRegistration() {
    this.user = {};
    this.errorMsg = "";
    this.registration = !this.registration;
  }

}
